import { MultiChangeEvent, PagedMultiSelectField, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { CostCategoryOptionResource } from "../../../../shared/types/costCategory";
import { costCategoryService } from "../api/costCategoryService";

interface Props {
	name: string;
	label: string;
	onChange: (e: MultiChangeEvent<CostCategoryOptionResource>) => void;
	disabled?: boolean;
	required?: boolean;
}

const fetchConfig = laravelServiceSelectFetchConfig(costCategoryService);
export const CostCategoryMultiSelectField: FC<Props> = ({ name, label, onChange, disabled, required = false }) => {
	return (
		<PagedMultiSelectField
			name={name}
			label={label}
			onChange={onChange}
			disabled={disabled}
			fetchConfig={fetchConfig}
			getLabel={(option) => option.name}
			clearable={true}
			required={required}
		/>
	);
};
